import React from 'react'
import h1 from './images/New/h1.jpg'
import park1 from './images/New/park1.jpg'
import area from './images/New/area.jpg'
import aero from './images/New/aero.jpg'
import man from './images/New/man.jpg'
import man1 from './images/New/man1.jpg'
import man3 from './images/New/man3.jpg'

const New = () => {
    return (
        <>
            <div className="colatainer-fluid py-1">
                <div className="bg9">
                    <div className=" relative w-full">
                        <div className="py-10 z-30 md:border-t-2 border-gray-100 md:mx-0 mx-2">
                            <h1 className='text-[#004A8B] text-[2.6rem] md:ml-[22rem] font-black'>News</h1>
                            <div className=" border-b-[.4rem] border-b-[#B5D1B3] md:ml-[22rem] py-1  w-[4rem]"></div>
                        </div>


                    </div>

                    <div className="grid md:grid-cols-3 gap-14 py-20 md:mx-20 mx-5 ">

                        <div className="col-1">

                            <div className="">
                                <div className='py-5 '>
                                    <h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>The ag property market is finding it’s new normal</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4 ">
                                <a href=""><img src={man3} alt="" className='rounded-full w-[200px]' /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1><div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>Historic Emu Creek on the market for first time in 155 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="">
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div></div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>LAWD CEO grounded in ‘servant leadership’</a>
                                <h1 className="text-[12px] text-gray-300 py-5">16 January 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4 ">
                                <a href=""><img src={park1} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1><div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>Historic Emu Creek on the market for first time in 155 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4 ">
                                <a href=""><img src={man} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1><div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>Historic Emu Creek on the market for first time in 155 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>
                        </div>

                        <div className="col-2">

                            <div className="">
                                <a href=""><img src={h1} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1><div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>Historic Emu Creek on the market for first time in 155 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4">
                                <a href=""><img src={man1} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1><div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>Historic Emu Creek on the market for first time in 155 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="">
                                <div className='py-5 '>
                                    <h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>The ag property market is finding it’s new normal</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4">
                                <a href=""><img src={man1} alt="" className='rounded-full w-[200px]' /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1><div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>Historic Emu Creek on the market for first time in 155 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>
                        </div>


                        <div className="col-3">

                            <div className="">
                                <a href=""><img src={area} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div></div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>High rainfall grazing opportunity in sought-after Jugiong district comes to market after 30 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4">
                                <div className='py-5 '>
                                    <h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div>
                                </div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>The ag property market is finding it’s new normal</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="">
                                <a href=""><img src={aero} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div></div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>High rainfall grazing opportunity in sought-after Jugiong district comes to market after 30 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                            <div className="py-4">
                                <a href=""><img src={man3} alt="" /></a>
                                <div className='py-5'><h1 className="text-[12px]">MEDIA RELEASE</h1>
                                    <div className=" border-b-[.4rem] border-b-[#B5D1B3] py-1  w-[4rem]"></div></div>
                                <a href='' className='text-[2rem] hover:text-[#B5D1B3] py-6 font-black text-[#004A8B]'>High rainfall grazing opportunity in sought-after Jugiong district comes to market after 30 years</a>
                                <h1 className="text-[12px] text-gray-300 py-5">07 February 2023</h1>
                                <div className="border-b-2 border-b-[#B5D1B3] py-1"></div>
                            </div>

                        </div>


                    </div>

                </div>
            </div>
        </>
    )
}

export default New